import { render } from "./PracticesReview.vue?vue&type=template&id=8da7d712&scoped=true"
import script from "./PracticesReview.vue?vue&type=script&lang=js"
export * from "./PracticesReview.vue?vue&type=script&lang=js"

import "./PracticesReview.vue?vue&type=style&index=0&id=8da7d712&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8da7d712"]])

export default __exports__